export default function BackCoverPage() {
  return (
    <section className="page back-cover" data-testid="page-back-cover">
      <div className="grain" />
      <div className="page-inner">
        <div className="big-sun" />
        <div className="eyebrow" style={{ alignSelf: "center" }}>Thank You</div>
        <h2>
          Let’s build a <em>brighter,<br />greener</em> Karnataka — together.
        </h2>
        <p className="signature">— The INPACE POWER Team</p>
        <div className="stamp">Inpace Power · Bangalore · MMXXVI · inpacepowers.com</div>
      </div>
    </section>
  );
}
